const COLORS = {
  default: 'text-slate-500/80 bg-gray-50 text-gray-600 ring-gray-500/10',
  white: 'bg-gray-50 text-gray-600 ring-gray-500/10',
  slate: 'bg-slate-50 text-slate-500 !ring-slate-500/10',
  light: 'bg-gray-50 text-gray-600 ring-gray-500/10',
  red: 'bg-red-50 text-red-700 ring-red-600/10',
  green: 'bg-green-50 text-green-700 ring-green-600/20',
  blue: 'bg-blue-50 text-blue-700 ring-blue-700/10',
  amber: 'bg-orange-50 text-orange-600 ring-orange-600/20',
  indigo: 'bg-indigo-50 text-indigo-700 ring-indigo-700/10',
  yellow: 'bg-yellow-50 text-yellow-700 ring-yellow-700/10',
  purple: 'bg-purple-50 text-purple-700 ring-purple-700/10',
  pink: 'bg-pink-50 text-pink-700 ring-pink-700/10'
};

const BASE_CLASSES = [
  'h-[24px]',
  'rounded-full',
  'truncate',
  'py-1',
  'text-xs',
  'font-medium',
  'ring-1',
  'ring-inset',
  'max-w-full',
  'relative',
  'inline-flex',
  'justify-center',
  'text-xs',
  'px-2.5',
  'font-hmedium',
  'items-center',
  'space-x-1'
];

export function Badge({
  color = 'default',
  label,
  icon,
  className
}: {
  color: 'default' | 'green' | 'red' | 'orange' | 'blue';
}) {
  const classNames = [...BASE_CLASSES, COLORS[color], className].join(' ');

  const Icon = icon;

  return (
    <div className={classNames}>
      {icon && <Icon className="w-3 h-3" />}
      <span className="truncate">{label}</span>
    </div>
  );
}
